<template>
  <NuxtLayout>
    <NuxtLoadingIndicator :duration="1500" color="#D2FF03" />
    <NuxtPage/>
  </NuxtLayout>
</template>

<script setup>
useSchemaOrg([
  defineOrganization({
    name: 'Drum Rudiments app',
    logo: 'https://media.drumrudiments.app/e4806be8-6b9d-4e42-a3da-90e055b2ab34/drum-rudiments-icon.png',
    sameAs: [
      'https://www.facebook.com/drumrudimentsapp/',
      'https://www.instagram.com/drumrudimentsapp/'
    ]
  }),
  defineWebSite({
    name: 'Drum Rudiments app'
  }),
  defineWebPage(
    {
      name: 'Drum Rudiments App - Learn Drum Rudiments Online',
      description: 'Learn drum rudiments online with Drum Rudiments. Get access to drum rudiment tutorials, progress tracking, and personalized practice sessions. Start your 7-day free trial today!',
      url: 'https://www.drumrudiments.app',
      image: 'https://media.drumrudiments.app/e4806be8-6b9d-4e42-a3da-90e055b2ab34/drum-rudiments-icon.png'
    }
  ),
])
</script>